import { FC, useEffect, useState } from 'react';
import { AlertFooter } from '../../../components/AlertFooter';
import { Button } from '../../../components/Button';
import { TripTypeSelector } from '../../../components/TripTypeSelector';
import {
  closeEditTripType,
  saveTripType,
  useEditTripTypeAlertState,
} from '../../../services/history';
import { TripType } from '../../../services/tripType';
import { HistoryAlertEdit } from '../HistoryAlertEdit';
import { FormattedMessage } from 'react-intl';

interface EditTripTypeProps {}

export const EditTripType: FC<EditTripTypeProps> = () => {
  const state = useEditTripTypeAlertState();
  const [value, setValue] = useState<TripType | null>(null);
  const tripType = state?.flatTrip.tripTypeOverride.tripType;

  useEffect(() => {
    if (tripType) {
      setValue(tripType);
    }
  }, [tripType]);

  if (!state || !value) {
    return null;
  }

  return (
    <HistoryAlertEdit
      open
      onClose={closeEditTripType}
      title={
        <label htmlFor="trip-type">
          <FormattedMessage id="Trip.Type" />
        </label>
      }
      description={
        <>
          <FormattedMessage id="Trip.Type.Change.Alert" />:
        </>
      }
    >
      <TripTypeSelector tripType={value} onChange={setValue} />
      <AlertFooter>
        <Button variant="text" onClick={closeEditTripType}>
          <FormattedMessage id="Cancel" />
        </Button>
        <Button onClick={() => saveTripType(value)}>
          <FormattedMessage id="Save" />
        </Button>
      </AlertFooter>
    </HistoryAlertEdit>
  );
};
